import React, { Component } from 'react';
import { PROMO_URLS, API_URLS } from '../helpers/api/API_URLS';
import { basicGET, basicJSONPOST, basicJSONDELETE } from '../helpers/api/fetchParams';

import { SearchForm } from '../helpers/uiComponents/Search';
import { Reload } from '../helpers/uiComponents/Reload';
import { ActionTabs } from '../helpers/uiComponents/ActionTabs';
import { CloseProfile } from '../helpers/uiComponents/CloseProfile';
import { ResultList } from '../helpers/uiComponents/ResultList';
import { InputRow } from '../helpers/uiComponents/InputRow';

import { getAllPromotions } from '../data/servicePromotions';

import {
	accordian, hidePopup, showPopup, toggleStatus, testLoginExpires, tabChange
} from '../helpers/uiFunctions/uiActions';

function isAssigned(clientCode, clientList) {
	var checked = false;
	if (clientList.includes(clientCode)) {
		checked = true;
	}
	return checked;
}

class Ecampaigns extends Component {

	constructor(props) {
		super(props);
		this.state = {
			allCampaigns: [],
			currentCampaign: null,
			clients: [],
			emailTemplates: [],
		}
		this.load = this.load.bind(this);
		this.updateField = this.updateField.bind(this);
		this.updateWidgetField = this.updateWidgetField.bind(this);
		this.updateEventField = this.updateEventField.bind(this);
		this.assignWidget = this.assignWidget.bind(this);
		this.saveCampaign = this.saveCampaign.bind(this);
	}
	componentDidMount() {
		this.loadPromotions();
	}
	componentDidUpdate(prevProps) {
		try {
			if( this.props.clients && (this.props.clients !== prevProps.clients )) {
				//console.log("update client list");
				var activeClients = this.props.clients.filter( client => { return client.status === "active"; });
				this.setState({
					clients: activeClients,
				});
			}

			if( this.props.sgTemplates && (this.props.sgTemplates !== prevProps.sgTemplates )) {
				// console.log("update sgTemplates list");
				this.setState({
					emailTemplates: this.props.sgTemplates,
				});
			}
		} catch (error) {
			console.log(error);
		}
	}
	loadPromotions() {
		getAllPromotions().then(promotions => {
			var campaigns = promotions.filter( prom => { return prom.promoType !== "coupon"; });
				campaigns = campaigns.sort((a, b) => b.promoId - a.promoId);

			this.setState({
				allCampaigns: campaigns,
			});
		})
	}
	load(id) {
		this.setState({ currentCampaign: null });

		fetch(PROMO_URLS.promo+id, basicGET(localStorage.getItem("token")))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			console.log(data.result);
			this.setState({ currentCampaign: data.result });
		})
		.then(() => {
			document.querySelector("#ecampaigns-profile-column .profile").style.display = "block";
		})
		.catch(error => console.log(error));
	}
	resetProfile() {
		this.setState({
			currentCampaign: null,
		});
	}
	addCampaign() {
		testLoginExpires();
		let name = document.getElementById("newCampaignName").value;
		let type = document.getElementById("newPromoType").value;
		var body = {
			"name": name,
			"promoType": type,
		}
		fetch(PROMO_URLS.promo, basicJSONPOST(localStorage.getItem("token"), body))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(() => {
			// console.log(data);
			hidePopup('addCampaignForm');
			this.loadPromotions();
		})
		.catch(error => console.log(error));
	}
	updateField(e) {
		var val;
		if (e.target.type === "checkbox") {
			val = e.target.checked;
		} else {
			val = e.target.value;
		}
		var prop = e.target.name;
		var state = this.state.currentCampaign;
		state[prop] = val
		this.setState({currentCampaign: state});
	}
	updateWidgetField(e) {
		var val;
		if (e.target.type === "checkbox") {
			val = e.target.checked;
		} else {
			val = e.target.value;
		}		
		var prop = e.target.name;
		var index = e.target.id;
		var state = this.state.currentCampaign;
		state.widgets[index][prop] = val;
		
		this.setState({currentCampaign: state});
	}
	updateRulesFields(widget) {
		// console.log("update rules");
		var groups = document.querySelectorAll('#series-inputs .tab.active .campaign-rules .trigger-group');
		var arr = [];
		for (var i = groups.length - 1; i >= 0; i--) {
			var newFieldValues = {};

			var field = groups[i].querySelector('select[name="field"]').value;
			var value = groups[i].querySelector('input[name="value"]').value;
			var comparison = groups[i].querySelector('select[name="comparison"]').value;
			var index = groups[i].querySelector('input[name="index"]').value;
			
			newFieldValues["field"] = field;
			newFieldValues["value"] = value;
			newFieldValues["comparison"] = comparison;
			newFieldValues["index"] = index;

			 arr.push(newFieldValues);
		}

		widget.predicate.rules = arr;

		//.log(widget);
		
		return widget;
	}
	updateEventField(e) {
		// console.log("update event field");
		var val = e.target.value;
		var prop = e.target.name;
		// console.log(prop, val);
		var index = e.target.closest('div.event').dataset.index;
		var widgetIndex = e.target.closest('div.tab').dataset.index;
		var state = this.state.currentCampaign;

		state.widgets[widgetIndex].events[index][prop] = val;
		
		this.setState({currentCampaign: state});
	}
	saveCampaign() {
		// console.log("save campaign");
		var body = this.state.currentCampaign;
		delete body.widgets;

		fetch(PROMO_URLS.promo, basicJSONPOST(localStorage.getItem("token"), body))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong while saving the campaign ...'); }
		})
		.then(data => {
			console.log(data);
		})
		.catch(error => console.log(error));
	}
	addWidget() {
		// console.log("add widget");
		let newWidget = {
			"name": "New Widget",
			"promoId": this.state.currentCampaign.promoId,
			"type": "email",
			"clientCodes": [],
			"predicate": {
				"rules": []
			}
		}
		fetch(PROMO_URLS.widget, basicJSONPOST(localStorage.getItem("token"), newWidget))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong while saving the widgets ...'); }
		})
		.then(data => {
			console.log(data);
			if (data.success === true) {
				var stateUpdate = this.state.currentCampaign;
				stateUpdate.widgets.push(data.result);
				this.setState({currentCampaign: stateUpdate})
			}
		})
		.catch(error => console.log(error));
		
	}
	saveWidget(newWidget, render) {
		let body;
		if (newWidget) {
			body = newWidget;
		} else {
			var index = document.querySelector("#series-inputs .tab.active").getAttribute('data-index');
			// console.log("widget index: "+index);

			body = this.state.currentCampaign.widgets[index];
			// console.log("body before update rules function:", body);
			
			this.updateRulesFields(body);
		}
		// console.log("body after update rules function:", body);

		console.log(body)


		fetch(PROMO_URLS.widget, basicJSONPOST(localStorage.getItem("token"), body))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong while saving the widgets ...'); }
		})
		.then(data => {
			console.log(data);
			if (render !== false) {
				this.loadPromotions();
			}
		})
		.catch(error => console.log(error));
	}
	deleteWidget() {
		var widgetId = document.querySelector("#series-inputs .tab.active").getAttribute('data-widgetid');
		widgetId = parseInt(widgetId, 10);
		var body = {"widgetId": widgetId}
		// console.log(body);
		fetch(PROMO_URLS.widget, basicJSONDELETE(localStorage.getItem("token"), body))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong while deleting the widgets ...'); }
		})
		.then(data => {
			// console.log(data);
			if (data.success === true) {
				var update = this.state.currentCampaign;
				update.widgets = update.widgets.filter( widget => { return widget.widgetId !== widgetId; });
				// console.log(update);
				this.setState({currentCampaign: update});
			}
		})
		.catch(error => console.log(error));
	}
	assignWidget(clientCode, widgetIndex) {
		// add clientCode to state
		// console.log("input: "+clientCode+" : "+widgetIndex)
		var update = this.state.currentCampaign;
		var currentClients = update.widgets[widgetIndex].clientCodes;
		if (currentClients.includes(clientCode)) {
			// console.log(clientCode+" is in the list");
			for( var i = 0; i < currentClients.length; i++){ 
			   if ( currentClients[i] === clientCode) {
			     currentClients.splice(i, 1); 
			   }
			}
		} else {
			// console.log(clientCode+" is not in the list");
			currentClients.push(clientCode);
		}
		// console.log("current clien list after push/splice", currentClients);

		update.widgets[widgetIndex].clientCodes = currentClients;
		this.setState({currentCampaign: update});

		// console.log("new state", this.state.currentCampaign);
	}
	addEvent() {
		// console.log("add event");
		var index = document.querySelector("#series-inputs .tab.active").getAttribute('data-index');
		var stateUpdate = this.state.currentCampaign;
		// console.log(widgetId);
		stateUpdate.widgets[index].events.push(
			{ "days": null, "hours": null, "type": "email", "template": null, "content": null },
		);
		
		// console.log(stateUpdate);
		this.setState({currentCampaign: stateUpdate}); // update the state to update UI

	}
	deleteEvent(widgetId, index) {
		var campaign = this.state.currentCampaign;
		var widgets = campaign.widgets
		for (var i = widgets.length - 1; i >= 0; i--) {
			if ( widgets[i].widgetId === widgetId ) {
				widgets[i].events.splice(index, 1);
			}
		}
		campaign.widgets = widgets;
		this.setState({currentCampaign: campaign});
	}
	testEvent(eventId) {
		var emails = document.querySelector("#testEvent-"+eventId).value;
		// console.log(eventId, emails);
		fetch(API_URLS.CRM+"/validate/"+eventId+"?email="+emails, basicJSONPOST(localStorage.getItem("token")))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong while testing the event links ...'); }
		})
		.then(data => {
			// console.log(data);
			alert("Success! "+data.message);
		})
		.catch(error => console.log(error));
	}
	addRule(index) {
		// console.log("add rule");
		var update = this.state.currentCampaign;
		var rules = update.widgets[index].predicate.rules;
		rules.push({"field": null, "value": null, "comparison": null});

		this.setState({currentCampaign: update}); // update the state to update UI
	}
	deleteRule(index) {
		document.querySelectorAll(".tab.active .campaign-rules .trigger-group")[index].remove();
	}

	render() {
		const { allCampaigns, currentCampaign, emailTemplates, clients } = this.state;
		return (
			<div className="columns">
				<Reload click={() => this.loadPromotions()} />
{/*left column*/}
				<div className="column left-column" id="ecampaigns-column">
{/*create a new email campaign*/}
					<section className="section">
						<form className="form popup-form" id="addCampaignForm" style={{display: 'none'}}>
							<i className="fas fa-times icon" onClick={() => hidePopup("addCampaignForm")} style={{float: 'right'}}></i>
							<h3>Add New Campaign</h3>
							<p className="promo-error"></p>
							<input type="text" name="name" id="newCampaignName" placeholder="Campaign Name" />
							<InputRow 
								type="select" property="promoType" id="newPromoType"
								options={[
									{ "name": "Automated Campaign", "value": "automation" },
									{ "name": "RLM Stage", "value": "rlmstage" }
								]}
							/>
							<div className="input-row">
								<input type="button" className="button is-info" onClick={() => this.addCampaign()} value="Add Campaign" />
							</div>
						</form>
					</section>
{/*count and search*/}
					<section className="section">
						<h3>All Campaigns: {allCampaigns.length ? (allCampaigns.length) : ("Loading...")}</h3>
						<SearchForm page="ecampaigns" />
					</section>
{/*filter tabs and result list*/}
					<div className="list-tabs">
						<div className="tab" id="campaigns-tab-1" onClick={() => toggleStatus("all", "campaigns-tab-1", "ecampaigns")}>All</div>
						<div className="tab new" onClick={() => showPopup("addCampaignForm")}>New Campaign</div>
					</div>
					<div className="list-label">CAMPAIGN NAME <span className="uptime-label"></span></div>
					<ResultList
						page={"ecampaigns"}
						data={allCampaigns}
						load={this.load}
					/>
				</div>

{/*right column*/}
				<div className="column profile-column" id="ecampaigns-profile-column">
					<div className="profile">
{(currentCampaign) && ( <React.Fragment>
						<div className="profile-header">
{/*header*/}
							<h3 className="profile-name">{currentCampaign.name}</h3>
							<CloseProfile reset={() => this.resetProfile()} />
						</div>
						<div className="profile-form">
{/*campaign settings*/}
							<div className="input-group">
								<div className="accordian-title active" onClick={accordian}>
									<h4>Campaign Configuration</h4>
								</div>
								<div className="accordian-body active">
									<div className="tabs-wrapper">
										<div className="action-tabs">
											<ActionTabs handleSave={this.saveCampaign} />
										</div>
									</div>
									<InputRow label="Name" type="text" value={currentCampaign.name} property="name" onChange={this.updateField} />
									<InputRow label="promoCode" type="text" value={currentCampaign.promoCode} property="promoCode" disabled description="Promotions and Email Campaigns are stored in the same DB table so they share the identifier 'promoCode'. Email Campaigns should not be thought of as Promotions." />
									<InputRow 
										label="Campaign Type" type="select" property="promoType" value={currentCampaign.promoType} onChange={this.updateField}
										options={[
											{ "name": "Automated Campaign", "value": "automation" },
											{ "name": "RLM Stage", "value": "rlmstage" }
										]}
									/>

									<InputRow
										label="Testing" type="checkbox" value={currentCampaign.testing} property="testing"
										onChange={this.updateField}
										description={"Configure emails and phone numbers below. Only leads with those values are processed"}
									/>

									<InputRow label="Test Addresses" type="text" value={currentCampaign.testEmail} property="testEmail" onChange={this.updateField}/>
									<InputRow label="Test Phone Numbers" type="text" value={currentCampaign.testPhone} property="testPhone" onChange={this.updateField}/>
								</div>
							</div>
{/*email series*/}
							<div className="input-group">
								<div className="accordian-title" onClick={accordian}>
									<h4>Email Series</h4>
								</div>
								<div className="accordian-body">
									<div className="tabs-wrapper">
										<div id="series-tabs" className="tabs">
											{(currentCampaign.widgets) && (
												currentCampaign.widgets.map( (widget, index) => (widget.type === "email") &&
													( <React.Fragment key={index}>
														<div key={index} id={"tab-"+index} className={"tab series-tab series-"+index}
															 onClick={() => tabChange("series", index)} >
															{widget.name}
														</div>
													</React.Fragment> )
												)
											)}
										</div>
										<div className="action-tabs">
											<ActionTabs
												handleAdd={() => this.addWidget()}
												handleSave={() => this.saveWidget(null, false)}
												handleDelete={() => this.deleteWidget()}
											/>
										</div>
									</div>

									<div id="series-inputs" className="inputs">
										{(currentCampaign.widgets) && (
											currentCampaign.widgets.map((widget, index) => (widget.type === "email") &&
												(<React.Fragment key={index}>
													<div id={"series-"+index} className={"tab series-"+index} data-index={index} data-widgetid={widget.widgetId}>
														<InputRow label="Series Name" type="text" value={widget.name} property="name" id={index} onChange={this.updateWidgetField} />
														<InputRow label="Series Active?" type="checkbox" value={widget.active} id={index} onChange={this.updateWidgetField} property="active" />

														<React.Fragment>
															<h4>Rules</h4>
															<div className="campaign-rules">
																<div className="rules-labels">
																	<div>Lead Field</div>
																	<div>Filter</div>
																	<div>Field Value</div>
																</div>

																{(widget.predicate) && (
																	widget.predicate.rules.map((rule, index) => (
																		<div className="trigger-group" key={index}>
																			<InputRow type="select" property="field" value={rule.field} options={
																				[
																					{"name": "estimateDate", "value": "estimateDate"},
																					{"name": "invoiceDate", "value": "invoiceDate"},
																					{"name": "deliveryDate", "value": "deliveryDate"},
																					{"name": "estimatedDeliveryDate", "value": "estimatedDeliveryDate"},
																					{"name": "installDate", "value": "installDate"},
																					{"name": "paymentDate", "value": "paymentDate"},
																					{"name": "carpetCleaningDate", "value": "carpetCleaningDate"},

																					{"name": "address1", "value": "address1"},
																					{"name": "address2", "value": "address2"},
																					{"name": "adPackage", "value": "adPackage"},
																					{"name": "area", "value": "area"},
																					{"name": "brand", "value": "brand"},
																					{"name": "campaign", "value": "campaign"},
																					{"name": "carpetCleaningTime", "value": "carpetCleaningTime"},
																					{"name": "channel", "value": "channel"},
																					{"name": "city", "value": "city"},
																					{"name": "clientCode", "value": "clientCode"},
																					{"name": "comments", "value": "comments"},
																					{"name": "company", "value": "company"},
																					{"name": "country", "value": "country"},
																					{"name": "department", "value": "department"},
																					{"name": "email", "value": "email"},
																					{"name": "emailId", "value": "emailId"},
																					{"name": "estimateTime", "value": "estimateTime"},
																					{"name": "firstName", "value": "firstName"},
																					{"name": "form", "value": "form"},
																					{"name": "formType", "value": "formType"},
																					{"name": "installTime", "value": "installTime"},
																					{"name": "invoiceNumber", "value": "invoiceNumber"},
																					{"name": "item", "value": "item"},
																					{"name": "keyword", "value": "keyword"},
																					{"name": "labor", "value": "labor"},
																					{"name": "lastName", "value": "lastName"},
																					{"name": "location", "value": "location"},
																					{"name": "locationCode", "value": "locationCode"},
																					{"name": "logo", "value": "logo"},
																					{"name": "name", "value": "name"},
																					{"name": "orgName", "value": "orgName"},
																					{"name": "orgType", "value": "orgType"},
																					{"name": "otherProductInterest", "value": "otherProductInterest"},
																					{"name": "phone", "value": "phone"},
																					{"name": "plan", "value": "plan"},
																					{"name": "planInterest", "value": "planInterest"},
																					{"name": "planNumber", "value": "planNumber"},
																					{"name": "platform", "value": "platform"},
																					{"name": "postalCode", "value": "postalCode"},
																					{"name": "productCode", "value": "productCode"},
																					{"name": "productInterest", "value": "productInterest"},
																					{"name": "productName", "value": "productName"},
																					{"name": "productType", "value": "productType"},
																					{"name": "projectDetails", "value": "projectDetails"},
																					{"name": "promoCode", "value": "promoCode"},
																					{"name": "referralName", "value": "referralName"},
																					{"name": "roomCount", "value": "roomCount"},
																					{"name": "salesRep", "value": "salesRep"},
																					{"name": "serviceCode", "value": "serviceCode"},
																					{"name": "serviceInterest", "value": "serviceInterest"},
																					{"name": "shipAddress1", "value": "shipAddress1"},
																					{"name": "shipAddress2", "value": "shipAddress2"},
																					{"name": "shipCity", "value": "shipCity"},
																					{"name": "shipPostalCode", "value": "shipPostalCode"},
																					{"name": "shipState", "value": "shipState"},
																					{"name": "sms360", "value": "sms360"},
																					{"name": "source", "value": "source"},
																					{"name": "state", "value": "state"},
																					{"name": "stage", "value": "stage"},
																					{"name": "storeNumber", "value": "storeNumber"},
																					{"name": "timeFrame", "value": "timeFrame"},
																					{"name": "trackingNumber", "value": "trackingNumber"},
																					{"name": "trigger", "value": "trigger"},
																					{"name": "trigger2", "value": "trigger2"},
																					{"name": "zapierTrigger", "value": "zapierTrigger"}
																				]
																			} />
																			<InputRow type="select" property="comparison" value={rule.comparison} options={[
																				{"name": "Equals", "value": "eq"},
																				{"name": "Does not equal", "value": "ne"},
																				{"name": "Exists", "value": "ex"},
																				{"name": "Does not exist", "value": "nex"},
																				{"name": "Greater than", "value": "gt"},
																				{"name": "Less than", "value": "lt"},
																				{"name": "Like", "value": "lk"},
																				{"name": "Not like", "value": "nlk"},
																				{"name": "In list", "value": "in"},
																				{"name": "Not in list", "value": "nin"}
																				]}
																			/>
																			<InputRow type="text" property="value" value={rule.value} />
																			<input type="hidden" value={index} name="index" />
																			<div onClick={() => this.deleteRule(index)}><i className="far fa-trash-alt icon"></i></div>
																		</div>
																	)
																))}

																<button className="button" onClick={() => this.addRule(index)}>Add Rule <i className="fas fa-plus"></i></button>
															</div>
														</React.Fragment>
														

														<h4>Emails</h4>
														<div className="event-list">
															{(widget.events && widget.events.length > 0) && (
																widget.events.map((event, index) =>
																	( <React.Fragment key={index}>
																		<div className={"event event-"+index} data-index={index} data-widgetid={widget.widgetId}>
																			<button className="button" onClick={() => this.deleteEvent(widget.widgetId, index)}><i className="far fa-trash-alt icon"></i></button>
																			<InputRow label="Event ID (for email testing)" type="text" value={event.eventId} property="eventId" disabled />
																			<InputRow label="Event Name" type="text" value={event.name} property="name" onChange={this.updateEventField} />
																			<InputRow label="Event Type" type="select" property="type" value={event.type} hideSelectOption="true" onChange={this.updateEventField} options={
																				[
																					{"name": "email", "value": "email"},
																					{"name": "text message", "value": "sms"}
																				]
																			} />

																			{(event.type === "email") && (
																				<InputRow label="Event Email Template" type="select" value={event.template} property="template" options={emailTemplates} onChange={this.updateEventField} />
																			)}
																			{(event.type === "sms") && (
																				<React.Fragment>
																					<InputRow label="Event SMS Content" type="textarea" rows="10" value={event.content} property="content" onChange={this.updateEventField} />
																					<p>Available variables for use in SMS messages: {'{{url_base}}'}, {'{{first_name}}'}, {'{{last_name}}'}, {'{{address_line_1}}'}, {'{{address_line_2}}'}, {'{{city}}'}, {'{{state_province_region}}'}, {'{{postal_code}}'}, {'{{country}}'}, {'{{phone_number}}'}, {'{{retailer_phone}}'}, {'{{retailer_name}}'}, {'{{retailer_address}}'}, {'{{retailer_city}}'}, {'{{date}}'}, {'{{time}}'}</p>
																				</React.Fragment>
																			)}

																			<React.Fragment>
																				<InputRow label="Hours From Lead Submission" type="text" value={event.hours} property="hours" onChange={this.updateEventField} />
																				<InputRow label="Days From Lead Submission" type="text" value={event.days} property="days" onChange={this.updateEventField} />
																			</React.Fragment>

																			{(event.type === "email") && (
																				<div className="test-event">
																					<InputRow label="Test Report Recipient(s):" type="text" id={"testEvent-"+event.eventId} property="testEmail" description="Provide email address(es). Comma separated list if more than one." />
																					<button className="button" onClick={() => this.testEvent(event.eventId)}>Send Test</button>
																				</div>
																			)}

																		</div>
																	</React.Fragment> )
																)
															)}
														</div>
														<button className="button" onClick={() => this.addEvent()}>Add Event <i className="fas fa-plus"></i></button>

														<React.Fragment>
															<h4>Clients Participating</h4>
															<h3>Velocity</h3>
															<ul className="promo-clientList">
																{clients.map((client, velocity) => (client.velocity === true) &&
																	( <React.Fragment key={client.clientCode}>
																		<li>
																			<input type="checkbox" id={widget.type+"-"+client.clientCode} onChange={() => this.assignWidget(client.clientCode, index)} checked={isAssigned(client.clientCode, widget.clientCodes)} />
																			<span>{client.name}</span>
																			<div>
																				<p><em>Package: {(client.servicePackage) ? ( client.servicePackage ):( "N/A" )} </em></p>
																				<p><em>Colorwall: {((client.options.colorWall) && (client.options.colorWall === "1")) ? ( "Enabled" ):( "No" )}</em></p>
																			</div>
																		</li>
																	</React.Fragment> )
																)}
															</ul>
															<h3>Legacy & Other</h3>
															<ul className="promo-clientList">
																{clients.map((client, velocity) => (client.velocity !== true) &&
																	( <React.Fragment key={client.clientCode}>
																		<li>
																			<input type="checkbox" id={widget.type+"-"+client.clientCode} onChange={() => this.assignWidget(client.clientCode, index)} checked={isAssigned(client.clientCode, widget.clientCodes)} />
																			<span>{client.name}</span>
																		</li>
																	</React.Fragment> )
																)}
															</ul>
														</React.Fragment>
													</div>
												</React.Fragment>)
											)
										)}
									</div>
								</div>
							</div>


						</div>
						</React.Fragment> )}
					</div>
				</div>


			</div>
		)
	}
}

export default Ecampaigns;


// WEBPACK FOOTER //
// ./src/component_ecampaigns/Ecampaigns.js